module.exports = __webpack_public_path__ + "img/Master-2.9fef4033.png";